import {HashRouter as Router, Route} from 'react-router-dom';
import React, {lazy, Suspense} from 'react';
import Loading from "../components/loading/Loading";
import {AUTHENTICATED_MSISDN, SessionService, SWITCHING_DATA} from "../providers/SessionService";
import {Redirect} from "react-router";
import {msisdnToIntl} from "../providers/MsisdnUtil";
import fetchRequest from "../providers/FetchRequest";
import {auth} from "../components/shared/constants";
import "core-js";

const Login = lazy(() => {
    return Promise.all([
        import("../components/login/Login"),
        new Promise(resolve => setTimeout(resolve, 200))
    ]).then(([moduleExports]) => moduleExports);
});
const SwitchingInfo = lazy(() => import('../components/switchingInfo/SwitchInfo'));

function PrivateRoute({component: Component, authed, ...rest}) {
    return (
        <Route
            {...rest}
            render={(props) => authed === true
                ? <Component {...props} />
                : <Redirect to={{pathname: '/login', state: {from: props.location}}}/>}
        />
    )
}

class App extends React.Component {

    constructor(props) {
        super(props);

        if (SessionService.get(AUTHENTICATED_MSISDN) !== undefined) {
            auth.authenticate();
        }
        this.state = {
            switchingDataLoaded: false
        };
    }

    render() {
        if (auth.isAuthenticated && !this.state.switchingDataLoaded) {
            return (<Loading/>);
        } else {
            return (
                <Router>
                    <Suspense fallback={<div/>}>
                        <Route exact path='/login'
                               render={() => <Login onAuthenticated={this.onAuthenticated.bind(this)}/>}/>
                        <PrivateRoute exact path='/'
                                      authed={auth.isAuthenticated && this.state.switchingDataLoaded}
                                      component={SwitchingInfo} />
                    </Suspense>
                </Router>);
        }
    };

    componentDidMount() {
        if (SessionService.get(AUTHENTICATED_MSISDN) !== undefined) {
            auth.authenticate();
            this.getSwitchingInfo();
        }
    }

    getSwitchingInfo() {
        this.setState({switchingDataLoaded: false});

        fetchRequest('GET', "/switch/" + msisdnToIntl(SessionService.get(AUTHENTICATED_MSISDN)))
            .then((response) => {
                SessionService.save(SWITCHING_DATA, response);
                this.setState({switchingDataLoaded: true});
            })
            .catch(() => {
                this.setState({switchingDataLoaded: false});
                SessionService.clear();
            });
    }

    onAuthenticated() {
        auth.authenticate();
        this.getSwitchingInfo();
    }
}

export default App;
